export function getDeviceType(): string {
  if (typeof navigator === 'undefined') return 'WEB';
  const ua = navigator.userAgent || '';

  const isAndroid = /Android/i.test(ua);
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1);

  if (isAndroid) return 'ANDROID';
  if (isIOS) return 'IOS';
  return 'WEB';
}
